import { trackRudderstack } from "jiffy-analytics";

const MAX_ETA_EVENTS_PER_PAGE = 10;

// Keyed by URL so the count resets automatically on client-side navigation
let etaPageKey = null;
let etaEventCount = 0;

const getEventCount = () => {
  const currentKey = window.location.href;
  if (currentKey !== etaPageKey) {
    etaPageKey = currentKey;
    etaEventCount = 0;
  }
  return etaEventCount;
};

const trackEtaEstimates = (data, { cap = false } = {}) => {
  try {
    if (!data?.success || !data?.estimates) return;

    Object.entries(data.estimates).forEach(([compositionId, estimate]) => {
      if (cap && getEventCount() >= MAX_ETA_EVENTS_PER_PAGE) return;

      trackRudderstack("Delivery Date Quoted", {
        composition_id: compositionId,
        variant_skus: estimate.variant_skus,
        delivery_date: estimate.delivery_date,
        cut_off_time: estimate.cut_off_time,
        quoted_hours_from_now: estimate.quoted_hours_from_now,
        business_line: estimate.business_line,
        zipcode: estimate.zipcode,
        dc_location_code: estimate.dc_location_code,
        timestamp: estimate.timestamp,
        shipping_method: estimate.shipping_method
      });

      if (cap) etaEventCount += 1;
    });
  } catch (error) {
    window.Honeybadger?.notify("trackEtaEstimates failed", {
      params: { error: error.message }
    });
  }
};

export default trackEtaEstimates;
